export const DRILL_DOWN_CHIP_BOX_CLASS =
  'inline-flex items-center gap-0.5 rounded-lg py-1 pr-1.5 pl-2';

export const DRILL_DOWN_CHIP_CLASS = [
  DRILL_DOWN_CHIP_BOX_CLASS,
  'group/chip cursor-pointer bg-brand-link/10 font-semibold text-brand-link ring-1 ring-brand-link/20 outline-none',
  'transition-[background-color,box-shadow] duration-200 motion-reduce:transition-none',
  'hover:bg-brand-link/16 hover:shadow-[0_0_14px_-6px_var(--color-brand-link)] hover:ring-brand-link/45',
  'focus-visible:ring-2 focus-visible:ring-brand-link/50',
].join(' ');

export const DRILL_DOWN_CHIP_ICON_CLASS = [
  'size-3.5 opacity-70 transition-[opacity,translate] duration-200 motion-reduce:transition-none',
  'group-hover/chip:translate-x-0.5 group-hover/chip:opacity-100',
].join(' ');
